import { Api } from '@/services/Api';

export default {
  /*  1. Get all data */
  getDefinitionOfDiseasesByCriteria(body = { keyword: '' }) {
    return Api().post('/DefinitionOfDiseases/GetDefinitionOfDiseasesByCriteria', body);
  },
  /*  2. Get one column */
  getDefinitionOfDiseases(id) {
    return Api().get(`/DefinitionOfDiseases/${id}`);
  },
  /*  3. Create one column */
  saveDefinitionOfDiseases(body) {
    return Api().post(`/DefinitionOfDiseases`, body);
  },
  /*  4. Delete one or more columns */
  deleteDefinitionOfDiseases(body) {
    return Api().post(`/DefinitionOfDiseases/DeleteDefinitionOfDiseases`, body);
  },
  /*  5. post one or more columns */
  postDefinitionOfDiseases(body) {
    return Api().post(`/DefinitionOfDiseases/PostDefinitionOfDiseases`, body);
  }
};
